/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LittleTiffAskRequest } from '../../models/little-tiff-ask-request';
import { LittleTiffAskResponse } from '../../models/little-tiff-ask-response';

export interface Ask$Params {
      body?: LittleTiffAskRequest
}

export function Ask(http: HttpClient, rootUrl: string, params?: Ask$Params, context?: HttpContext): Observable<StrictHttpResponse<LittleTiffAskResponse>> {
  const rb = new RequestBuilder(rootUrl, Ask.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LittleTiffAskResponse>;
    })
  );
}

Ask.PATH = '/api/LittleTiff/Ask';
